document.addEventListener("DOMContentLoaded", () => {
  const currentUrl = new URL(window.location.href);
  if (currentUrl.pathname.includes("metabolically-lean-weight-management")) {
    const urlVariantId = currentUrl.searchParams.get("variant");
    if (urlVariantId) {
      const options = document.querySelectorAll(".cstmOptions");
      if (options.length > 0) {
        options.forEach((element) => {
          const variantId = element.getAttribute("cstmvarint-id");
          if (variantId === urlVariantId) {
            console.log("Match found:", variantId);
            if (element) {
              element.click();
            }
          }
        });
      }
    }
  }
});
$(document).ready(function () {
  const utmSource = window.utmSettings.utmParams;
  console.log("utmpop>>>", utmSource);
  let add_cart = document.querySelector(
    ".product-form__buttons.second-click .product-form__submit"
  );
  let metafield_varinat = document.querySelectorAll(
    ".varinat_show .variant-under"
  );
  let pt_bt = document.querySelector("variant-radios").innerHTML;
  let All_varinat = document.querySelectorAll(".main-varinat");
  let Recommened_show = document.querySelectorAll(".Recommened_show");
  const Elem = document.querySelector('[varibox="upasell_variant-3"]');
  let next_class = document.querySelectorAll(".Popup_variant_1[checked]");
  let checkActive = document.querySelectorAll(".Popup_variant.selected");
  if (checkActive.length) {
    checkActive.forEach((item) => {
      let Varinatid = item.getAttribute("varibox");
      let activevarinat = document
        .querySelector(`.${Varinatid}.False.NOnextpop`)
        ?.closest("section")
        .querySelector(".corss-popup-button");
      activevarinat?.classList.add("combo-none");
      let Stickyactive = document
        .querySelector(`.${Varinatid}.False.NOnextpop`)
        ?.closest("section")
        .querySelector(".ts-sticky-addtocart .corss-popup-button");
      Stickyactive?.classList.add("combo-none");
      let activeReco = document
        .querySelector(`.${Varinatid}.False.nextpop`)
        ?.closest("section")
        .querySelector(".main-varinat");
      activeReco?.classList.add("combo-none");
      let activeRecoNext = document
        .querySelector(`.${Varinatid}.False.nextpop`)
        ?.closest("section")
        .querySelector(".Recommened_show");
      activeRecoNext?.classList.add("Show-Element");
    });
  }
  if (next_class.length) {
    next_class.forEach((item) => {
      var next_click = item.nextElementSibling;
      next_click.click();
      // console.log('next_click',next_click);
    });
  }
  let varinat_combo = document.querySelectorAll(".banner-variant-na");
  console.log("varinat_combo", varinat_combo);
  varinat_combo.forEach((combo) => {
    combo.addEventListener("click", () => {
      varinat_combo.forEach((com) => {
        com.classList.remove("active-click");
      });
      let At = combo.getAttribute("varinat");
      let price = combo.getAttribute("pric");
      let com_price = combo.getAttribute("comp");
      let Titl = combo.getAttribute("vari_title");
      let add_button = combo
        .closest(".banner-product1")
        .querySelector(".banner-product-add-to-cart");
      let banner_price = combo
        .closest(".banner-product1")
        .querySelector(".banner-price");
      let compare_price = combo
        .closest(".banner-product1")
        .querySelector(".banner-compare");
      let vari_title = combo
        .closest(".banner-product1")
        .querySelector(".banner-product-title");
      combo.classList.add("active-click");
      banner_price.innerText = `₹ ${price}`;

      compare_price.innerText = `₹ ${com_price}`;

      console.log("com_price", typeof com_price);
      console.log(`Value of com_price [${com_price}]`);

      console.log("add_button", add_button);
      vari_title.innerText = Titl;
      add_button.setAttribute("varinat-id", At);
    });
  });
  // console.log('next_class',next_class);
  //Opne Second NO THANKS ON POPUP
  var cut_btn = document.querySelectorAll(".new-combo-products .variant-cut");
  cut_btn.forEach((item) => {
    item.addEventListener("click", () => {
      console.log("kk");
      document.querySelector(".variant-pop").style.display = "none";
      document.querySelector("body").classList.remove("no-scroll");
      // let Recommened_show1 = item.closest('.shopify-section')?.querySelector('.Recommened_show');
      //  console.log('Recommened_show1',Recommened_show1);
      //  Recommened_show1?.classList.remove('Show-Element');
      document.querySelectorAll(".Recommened_show")?.forEach((rem) => {
        rem.classList.remove("Show-Element");
      });
      let add_cart1 = document.querySelector(
        ".new-combo-products .product-form__buttons .button--secondary.product-form__submit"
      );
      add_cart1 && add_cart1.click();
    });
  });
  //close  Second NO THANKS ON POPUP
  var cut_btn1 = document.querySelectorAll(".variant-cut");
  var popup_hide = document.querySelectorAll(".variant-pop");
  cut_btn1?.forEach((item) => {
    item.addEventListener("click", () => {
      let main = item.closest(".shopify-section").querySelector(".variant-pop");
      main.style.display = "none";
      let Recommened_show1 = item
        .closest(".shopify-section")
        ?.querySelector(".Recommened_show");
      Recommened_show1?.classList.remove("Show-Element");
      document.querySelector("body").classList.remove("no-scroll");
      let add_cart = document.querySelector(
        ".product-form__buttons.second-click .product-form__submit"
      );
      if (add_cart) {
        console.log("add_cart", add_cart);
        add_cart && add_cart.click();
      }
      let add_cart1 = item
        .closest("section")
        .querySelector(
          ".product-form__buttons .product-form__submit.button--secondary"
        );
      if (add_cart1) {
        add_cart1 && add_cart1.click();
      }
      let add_cart2 = item
        .closest("section")
        .querySelector(
          ".combo-spcl .product-form__buttons .product-form__submit"
        );
      if (add_cart2) {
        add_cart2 && add_cart2.click();
      }
    });
  });

  let lastClickedElement = null;
  if (metafield_varinat.length) {
    metafield_varinat.forEach((metbtn) => {
      metbtn.addEventListener("click", () => {
        if (lastClickedElement && lastClickedElement !== metbtn) {
          lastClickedElement.classList.remove("meta-click");
        }
        metbtn.classList.add("meta-click");
        let varinat_getAtt = metbtn
          .closest(".last_varinat_show")
          .querySelector(".last_varinat_show .variant_upgrade_btn");
        //console.log('varinat_getAtt',varinat_getAtt);
        let varinat_Att = metbtn.getAttribute("att");
        //   console.log('Get varinat Att',varinat_Att);
        varinat_getAtt.setAttribute("prd-id", varinat_Att);
        lastClickedElement = metbtn.classList.contains("meta-click")
          ? metbtn
          : null;
        document.querySelectorAll(".Show-message").forEach((message) => {
          message.classList.remove("Show-Element");
        });
        let sibling = metbtn.nextElementSibling;
        if (sibling && sibling.classList.contains("Show-message")) {
          sibling.classList.add("Show-Element");
        }
      });
    });
  }
  let combo_metafield_varinat = document.querySelectorAll(
    ".template-product-combo-product .varinat_show .variant-under"
  );
  combo_metafield_varinat?.forEach((com_item) => {
    com_item.addEventListener("click", () => {
      com_item.classList.add("meta-click");
      document.querySelector(".Show-message")?.classList.remove("Show-Element");
    });
  });

  //Open Recommend prodcut
  let Recom_pdp = document.querySelectorAll(".Recom_Add_btn");
  if (Recom_pdp.length) {
    Recom_pdp.forEach((Rec_btn) => {
      Rec_btn.addEventListener("click", () => {
        Rec_btn.classList.add("back-color");
        document.querySelector(".cross-banner").style.display = "none";
        setTimeout(() => {
          Rec_btn.classList.remove("back-color");
        }, "1000");
        let Att = Rec_btn.getAttribute("prd-id");
        let data = [];
        data.push({
          id: Att,
          quantity: 1,
          properties: {
            utm_source: utmSource,
          },
        });
        let formData = {
          items: data,
          sections: ["cart-drawer", "cart-count-bubble"],
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            return response.json();
          })
          .then((resp) => {})
          .catch((error) => {
            console.log("ERROR :", error);
          });
        setTimeout(() => {
          add_cart.click();
          document.querySelector("body").classList.remove("no-scroll");
          document.querySelector(".variant-pop").style.display = "none";
        }, 1000);
      });
    });
  }
  //Close Recommend prodcut

  let varti = document.querySelectorAll(".product-form__input .Popup_variant");
  let meta_varint = document.querySelectorAll(".total_varinat");
  let varti_len = varti.length;
  let final = varti_len / 2;
  //open varinat click
  document.body.addEventListener("click", (e) => {
    let target = e.target;
    target = target?.closest(".Popup_variant");
    if (target) {
      let varti_len = target
        .closest("variant-radios")
        .querySelectorAll(".Popup_variant");
      let ATT = "upasell_variant-3";
      let TargetAtt = target.getAttribute("varibox");
      let allActivevarinat = document.querySelectorAll(".corss-popup-button");
      if (allActivevarinat.length) {
        allActivevarinat.forEach((activeitem) => {
          activeitem.classList.remove("combo-none");
        });
      }
      let Mainvarinat = document.querySelectorAll(".main-varinat");
      if (Mainvarinat.length) {
        Mainvarinat.forEach((item) => {
          item.classList.remove("combo-none");
        });
      }
      let showStricky = document.querySelectorAll(
        ".ts-sticky-addtocart .corss-popup-button"
      );
      if (showStricky.length) {
        showStricky.forEach((item) => {
          item.classList.remove("Fiber-product");
        });
      }
      document
        .querySelectorAll(`.${TargetAtt}.False.NOnextpop`)
        .forEach((element) => {
          let activeVariant = element
            .closest("section")
            ?.querySelector(".corss-popup-button");
          activeVariant?.classList.add("combo-none");
        });

      document
        .querySelectorAll(`.${TargetAtt}.False.NOnextpop`)
        .forEach((element) => {
          document
            .querySelectorAll(".ts-sticky-addtocart .corss-popup-button")
            ?.forEach((stictbtn) => {
              stictbtn?.classList.add("combo-none");
            });
        });

      let activeReco = document
        .querySelector(`.${TargetAtt}.False.nextpop`)
        ?.closest("section")
        .querySelector(".main-varinat");
      //console.log('activeReco',activeReco);
      activeReco?.classList.add("combo-none");
      let activeRecoNext = document
        .querySelector(`.${TargetAtt}.False.nextpop`)
        ?.closest("section")
        .querySelector(".Recommened_show");
      activeRecoNext?.classList.add("Show-Element");
      console.log("activeRecoNext>>>>", activeRecoNext);
      // activeReco?
      if (ATT == TargetAtt) {
        let upsellInner = document.querySelector(`.${TargetAtt}.upsell_inner`);
        let main_popup = upsellInner?.closest(".variant-pop");
        main_popup?.classList.add("Fiber-product");
      } else {
        let upsellInner = document.querySelector(`.${TargetAtt}.upsell_inner`);
        let main_popup = upsellInner?.closest(".variant-pop");
        main_popup?.classList.remove("Fiber-product");
      }

      let last_varint = Number(target?.getAttribute("ind"));
      // console.log('last_varint',last_varint);
      // console.log('varti_len',varti_len);
      if (varti_len.length == last_varint) {
        document.querySelectorAll(".show-product")?.forEach((p) => {
          p.style.display = "block";
        });
        document
          .querySelectorAll("button.variant_upgrade_btn")
          ?.forEach((b) => {
            b.style.display = "none";
          });
      } else {
        document.querySelectorAll(".show-product")?.forEach((p) => {
          p.style.display = "none";
        });
        document
          .querySelectorAll("button.variant_upgrade_btn")
          ?.forEach((b) => {
            b.style.display = "block";
          });
      }
      meta_varint.forEach((meta_btn) => {
        meta_btn.style.display = "none";
      });
      target.classList.remove("selected");
      let varinat_meta = target.getAttribute("varibox");
      const varinat_show = document.querySelectorAll(
        `.varinat_show .${varinat_meta}`
      );
      varinat_show.forEach(function (variant) {
        variant.style.display = "flex";
      });
      let varinat_att = target.getAttribute("cstmvarint-id");
      document.querySelector('.product-form form.form input[name="id"]').value =
        varinat_att;
    }
  });

  //close variant click

  let total_butn = document.querySelectorAll(".Open_pop");
  let total_varinat = document.querySelectorAll(".cstmVariants .Popup_variant");

  let Select_btn = document.querySelector(".click_button .varinat_click");
  if (Select_btn) {
    Select_btn.addEventListener("click", () => {
      var miniCart = document.querySelector("cart-drawer");
      let uytu = document.querySelector(
        `.varinat_show .variant-under.meta-click`
      );
      if (uytu) {
        let attr = uytu.getAttribute("att");
        let data = [];
        data.push({
          id: attr,
          quantity: 1,
          properties: {
            utm_source: utmSource,
          },
        });
        let formData = {
          items: data,
          sections: miniCart.getSectionsToRender().map((section) => section.id),
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            return response.json();
          })
          .then((resp) => {
            miniCart.renderContents(resp);
            miniCart.classList.remove("is-empty");
            document.querySelector(".variant-pop").style.display = "none";
            document.querySelector("body").classList.remove("no-scroll");
          })
          .catch((error) => {
            console.log("ERROR :", error);
          });
        setTimeout(() => {
          if (metafield_varinat) {
            metafield_varinat.forEach((metremove) => {
              metremove.classList.remove("meta-click");
            });
          }
        }, 2000);
      } else {
        document.querySelector(".Show-message").classList.add("Show-Element");
      }
    });
  }
  let cross_button = document.querySelectorAll(".cross-button");
  if (cross_button.length) {
    let cross_remove1 = document.querySelectorAll(".Cross-sell-varinat");
    cross_button.forEach((cross_btn) => {
      cross_btn.addEventListener("click", () => {
        cross_button.forEach((cros_color) => {
          cros_color
            .closest(".Cross-sell-varinat")
            .classList.remove("back-color");
        });
        cross_btn.closest(".Cross-sell-varinat").classList.add("back-color");
        var miniCart = document.querySelector("cart-drawer");
        let Extra = document.querySelector(
          ".total_varinat .variant-under.meta-click"
        );
        let ATT = cross_btn.getAttribute("prd-id");
        let data = [];
        if (Extra) {
          let ATT1 = Extra.getAttribute("att");
          data.push(
            {
              id: ATT1,
              quantity: 1,
              properties: {
                utm_source: utmSource,
              },
            },
            {
              id: ATT,
              quantity: 1,
              properties: {
                utm_source: utmSource,
              },
            }
          );
        } else {
          data.push({
            id: ATT,
            quantity: 1,
          });
        }

        let formData = {
          items: data,
          sections: miniCart.getSectionsToRender().map((section) => section.id),
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            return response.json();
          })
          .then((resp) => {
            miniCart.renderContents(resp);
            miniCart.classList.remove("is-empty");
            document.querySelector(".variant-pop").style.display = "none";
            document.querySelector("body").classList.remove("no-scroll");
          })
          .catch((error) => {
            console.log("ERROR :", error);
          });
        setTimeout(() => {
          if (metafield_varinat) {
            metafield_varinat.forEach((metremove) => {
              metremove.classList.remove("meta-click");
            });
          }
          if (cross_remove1) {
            cross_remove1.forEach((crossbtn) => {
              crossbtn.classList.remove("back-color");
            });
          }
        }, 2000);
      });
    });
  }

  //  //Open First No Thanks button
  //  let next_pop = document.querySelectorAll('.POP-open');
  //  // let Recommened_show = document.querySelectorAll(".Recommened_show");
  //  let show_product =  document.querySelectorAll('.show-product');
  // // if(next_pop){
  //    next_pop?.forEach((next_pop1)=>{

  //    next_pop1.addEventListener('click',()=>{
  //      Recommened_show?.forEach((Recommened)=>{
  //       // Recommened.classList.add('Show-Element');
  //      })
  //      show_product.forEach((show)=>{
  //        show.style.display="none";
  //      })
  //      All_varinat.forEach((All)=>{
  //        All.style.display="none";
  //      })
  //      setTimeout(()=>{
  //        if(metafield_varinat){
  //         metafield_varinat.forEach((metremove)=>{
  //            metremove.classList.remove('meta-click');
  //         })
  //        }
  //      },2000);
  //    })
  //    })
  // // }
  //  //Close First No Thanks button

  //Open Banner Click
  let Banner = document.querySelectorAll(".prodct-image-banner");
  if (Banner.length) {
    Banner.forEach((Ban_btn) => {
      Ban_btn.addEventListener("click", () => {
        var miniCart = document.querySelector("cart-drawer");
        var outer_popup =
          Ban_btn.closest("section").querySelector(".variant-pop");
        var id1 = Ban_btn.getAttribute("prd-id");
        var DataSet = [];
        DataSet.push({
          id: id1,
          quantity: 1,
          properties: {
            utm_source: utmSource,
          },
        });
        var NewformData = {
          items: DataSet,
          sections: miniCart.getSectionsToRender().map((section) => section.id),
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(NewformData),
        })
          .then((response) => {
            return response.json();
          })
          .then((resp) => {
            console.log("resp", resp);
            miniCart.renderContents(resp);
            miniCart?.classList.remove("is-empty");
            // document.querySelector('.variant-pop').style.display="none";
            outer_popup.style.display = "none";
            document.querySelector("body").classList.remove("no-scroll");
            if (metafield_varinat) {
              metafield_varinat.forEach((metbtn) => {
                metbtn.classList.remove("meta-click");
              });
            }
          })
          .catch((error) => {
            console.log("ERROR :", error);
          });
      });
    });
  }
  //Close Banner click

  //Open Banner ADD TO CART Button
  let banner_button1 = document.querySelectorAll(".banner-product-add-to-cart");
  banner_button1.forEach((banner_button) => {
    let popup_show_hide = banner_button
      .closest(".shopify-section")
      .querySelector(".variant-pop");
    let recommend_hide = banner_button
      .closest(".shopify-section")
      .querySelector(".Recommened_show");
    let add_cart1 = banner_button
      .closest(".shopify-section")
      .querySelector(
        ".product-form__buttons .product-form__submit.button--secondary"
      );
    banner_button.addEventListener("click", () => {
      var miniCart = document.querySelector("cart-drawer");
      var id1 = banner_button.getAttribute("varinat-id");
      var DataSet = [];
      DataSet.push({
        id: id1,
        quantity: 1,
        properties: {
          utm_source: utmSource,
        },
      });
      var NewformData = {
        items: DataSet,
        sections: miniCart.getSectionsToRender().map((section) => section.id),
      };
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(NewformData),
      })
        .then((response) => {
          return response.json();
        })
        .then((resp) => {
          miniCart.renderContents(resp);
          miniCart?.classList.remove("is-empty");
          popup_show_hide.style.display = "none";
          recommend_hide?.classList.remove("Show-Element");
          document.querySelector("body").classList.remove("no-scroll");
          // add_cart1 && add_cart1.click();
        })
        .catch((error) => {
          console.log("ERROR :", error);
        });
    });
  });
  //Close Banner ADD TO CART Button
});

//Open [ Close  the Popup click outside of popup ]
document.body.addEventListener("click", (e) => {
  let Recommened_show_now = document.querySelectorAll(".Recommened_show");
  const popinner1 = document.querySelectorAll(".variant-pop");
  var clickedElement = event.target;
  if (clickedElement.classList.contains("variant-pop")) {
    var popup_main_box = clickedElement
      .closest("section")
      .querySelectorAll(".variant-pop");
    if (popup_main_box.length) {
      popup_main_box.forEach((main_pop) => {
        main_pop.style.display = "none";
      });
    }
    var stickybutton = document.querySelectorAll(".ts-sticky-addtocart");
    if (stickybutton.length) {
      stickybutton.forEach((item) => {
        item.classList.remove("showSticky");
        let next_Element = item.querySelector(".ts-variant-picker");
        next_Element.classList.add("show");
      });
    }
    document.querySelector("body").classList.remove("no-scroll");
    Recommened_show_now?.forEach((Recommened) => {
      Recommened?.classList.remove("Show-Element");
    });

    var popup_inner = clickedElement
      .closest("section")
      .querySelectorAll(".variant-pop-box");
    if (popup_inner.length) {
      popup_inner.forEach((inneritem) => {
        inneritem.addEventListener("click", (event) => {
          event.stopPropagation();
        });
      });
    }
  }
});

// document.body.addEventListener('click',(e)=>{
//  let Recommened_show_now1 = document.querySelectorAll(".Recommened_show");
//  let pop1 = document.querySelectorAll('.combo-spcl .variant-pop');
//  var clickedElement = event.target;
//   pop1?.forEach((popitem)=>{
//     if (clickedElement.contains(popitem)){
//          document.querySelector(".combo-spcl .variant-pop").style.display="none";
//          document.querySelector('body').classList.remove('no-scroll');
//          Recommened_show_now1?.forEach((Recommened)=>{
//          Recommened?.classList.remove('Show-Element');
//         })
//       }
//    })

// let innpop1 = document.querySelectorAll('.combo-spcl .variant-pop-box');
// innpop1?.forEach((inneritem)=>{
//   inneritem.addEventListener('click',(event)=>{
//     event.stopPropagation();
//   })
//  })
// })
// Close [ Close the Popup click outside of popup]
var Recommened_banner;
let GETATT;
window.addEventListener("DOMContentLoaded", function () {
  var buttons = document.querySelectorAll(".Open_pop");
  if (buttons.length) {
    buttons.forEach((btn) => {
      btn.addEventListener("click", function () {
        var clickedElement = this;
        var showpopupbox = clickedElement
          .closest("section")
          .querySelector(".variant-pop.Show-mainpopup");
        if (showpopupbox) {
          showpopupbox.style.display = "block";
          showpopupbox.classList.add("flix");
        }
        // clickedElement.closest('section').querySelector('.variant-pop.Show-mainpopup').classList.add('flix')
        $(".page-width").css({ "z-index": "auto" });
        document.querySelector("body").classList.add("no-scroll");
        var selectedVariant = document.querySelector(".Popup_variant.selected");
        var Attrubute1 = clickedElement
          .closest("section")
          .querySelectorAll(".Popup_variant.selected");
        var last_productshow1 = clickedElement
          ?.closest("section")
          .querySelector(".varinat_show");
        var additionalProduct = clickedElement
          .closest("section")
          .querySelector(".varinat_show");
        var Addclass = clickedElement
          .closest("section")
          .querySelector(".last_varinat_show");
        var hideAll = clickedElement
          ?.closest("section")
          .querySelectorAll(".total_varinat");
        var HideALLVarinat = clickedElement
          ?.closest("section")
          .querySelector(".varinat_show .variant_upgrade_btn");
        var main_popup_div = clickedElement
          ?.closest("section")
          .querySelectorAll(".main-varinat");
        var main_popup_banner = clickedElement
          ?.closest("section")
          .querySelectorAll(".main-varinat.combo-none");
        var newRecommened_banner = clickedElement
          ?.closest("section")
          .querySelector(".variant-pop-box");
        console.log("newRecommened_banner>>", newRecommened_banner);
        var stickybutton = document.querySelectorAll(".ts-sticky-addtocart");
        //   console.log('HideALLVarinat',HideALLVarinat);
        if (stickybutton.length) {
          stickybutton.forEach((item) => {
            item.classList.add("showSticky");
            let next_Element = item.querySelector(".ts-variant-picker");
            next_Element.classList.remove("show");
          });
        }
        if (main_popup_div.length) {
          main_popup_div.forEach((main_pop) => {
            main_pop.style.display = "block";
          });
        }
        // Recommened_banner = clickedElement?.closest('section').querySelector('.Recommened_show');
        // if(main_popup_banner.length>=1){
        //     //  console.log('main_popup_banner',main_popup_banner);
        //     // console.log('Recommened_banner',Recommened_banner);
        //       if(Recommened_banner){
        //         Recommened_banner.classList.add('Show-Element');
        //       }
        //    }
        if (Attrubute1.length) {
          Attrubute1?.forEach((GetAttru) => {
            GETATT = GetAttru.getAttribute("varibox");
            hideAll?.forEach((hidevarinat) => {
              hidevarinat.style.display = "none";
            });
            document.querySelectorAll(`.${GETATT}`).forEach((item) => {
              item.style.display = "flex";
            });
            // alert(GETATT);
            let sectec_varinat = document.querySelectorAll(`.${GETATT}`);
            // console.log('sectec_varinat',sectec_varinat);
            this.click();
          });
        }

        Recommened_banner = clickedElement
          ?.closest("section")
          .querySelector(`.Recommened_show#${GETATT}`);
        let singleRecommened_banner = clickedElement
          ?.closest("section")
          .querySelector(`.onlyrec#${GETATT}`);
        document.querySelectorAll(".Recommened_show").forEach((message) => {
          message.classList.remove("Show-Element");
        });

        if (newRecommened_banner) {
          if (singleRecommened_banner) {
            Recommened_banner.classList.add("Show-Element");
          }
        }
        // document.querySelectorAll('.onlyrec').forEach((message) => {
        //   message.classList.add('Show-Element');
        // });

        if (main_popup_banner.length >= 1) {
          console.log("main_popup_banner", main_popup_banner);
          // console.log('Recommened_banner',Recommened_banner);
          if (Recommened_banner) {
            Recommened_banner.classList.add("Show-Element");
          }
        }
        if (selectedVariant?.classList.contains("cstmOptions_last")) {
          if (additionalProduct) {
            var productToShow =
              additionalProduct.querySelector(".show-product");
            if (productToShow) {
              productToShow.style.display = "block";
              //  console.log("productToShow", productToShow);
            }
            if (HideALLVarinat) {
              //HideALLVarinat.forEach((hide_varint)=>{
              // HideALLVarinat.style.display="none";
              //})
            }
            if (Addclass) Addclass.classList.add("lastvarinatshow");
            if (last_productshow1) last_productshow1?.classList.add("lastnext");
          }
        } else {
          if (additionalProduct) {
            var productToShow =
              additionalProduct.querySelector(".show-product");
            if (productToShow) productToShow.style.display = "none";
            if (Addclass) Addclass.classList.remove("lastvarinatshow");
            if (last_productshow1)
              last_productshow1?.classList.remove("lastnext");
            if (HideALLVarinat) {
              HideALLVarinat.style.display = "block";
            }
          }
        }
      });
    });
  }
});

// Open First No Thanks button
let next_pop = document.querySelectorAll(".POP-open");
let All_varinat = document.querySelectorAll(".main-varinat");
let Recommened_show = document.querySelector(`.Recommened_show#${GETATT}`);
let show_product = document.querySelectorAll(".show-product");
let metafield_varinat = document.querySelectorAll(
  ".varinat_show .variant-under"
);
next_pop.forEach(function (next_pop1) {
  next_pop1.addEventListener("click", function () {
    var clickedElement = this;
    console.log("Recommened_banner", Recommened_banner);
    document.querySelectorAll(".Recommened_show")?.forEach((rem) => {
      rem.classList.remove("Show-Element");
    });
    if (Recommened_banner === null) {
      //let nextclick = this.parentElement;
      let nextclick = clickedElement
        ?.closest(".variant-pop-box")
        .querySelector(".Recommened_show .variant-cut");
      nextclick.click();
      console.log("nextclick", nextclick);
    } else {
      Recommened_banner.classList.add("Show-Element");
      show_product.forEach(function (show) {
        show.style.display = "none";
      });
      All_varinat.forEach(function (All) {
        All.style.display = "none";
      });
      setTimeout(function () {
        if (metafield_varinat) {
          metafield_varinat.forEach(function (metremove) {
            metremove.classList.remove("meta-click");
          });
        }
      }, 2000);
    }
  });
});
